// ==============================================================================
// Imports
// ==============================================================================

import React from "react";
import ReactDOM from "react-dom";

// ==============================================================================
// Support Function to copy styling
// ==============================================================================

const copyStyles = (source, target) => {
    Array.from(source.styleSheets).forEach(styleSheet => {
        // exclude the bootstrap css file which will throw an error
        if (
            styleSheet.href !==
            "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" &&
            styleSheet.href !==
            "https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap"
        ) {
            // For <style> elements
            let rules;
            try {
                rules = styleSheet.cssRules;
            } catch (err) {
                console.error(err);
            }
            if (rules) {
                const newStyleEl = source.createElement("style");

                // Write the text of each rule into the body of the style element
                Array.from(styleSheet.cssRules).forEach(cssRule => {
                    const { cssText, type } = cssRule;
                    let returnText = cssText;
                    // Check if the cssRule type is CSSImportRule (3) or CSSFontFaceRule (5) to handle local imports on a about:blank page
                    // '/custom.css' turns to 'http://my-site.com/custom.css'
                    if ([3, 5].includes(type)) {
                        returnText = cssText
                            .split("url(")
                            .map(line => {
                                if (line[1] === "/") {
                                    return `${line.slice(0, 1)}${
                                        window.location.origin
                                    }${line.slice(1)}`;
                                }
                                return line;
                            })
                            .join("url(");
                    }
                    newStyleEl.appendChild(source.createTextNode(returnText));
                });

                target.head.appendChild(newStyleEl);
            } else if (styleSheet.href) {
                // for <link> elements loading CSS from a URL
                const newLinkEl = source.createElement("link");

                newLinkEl.rel = "stylesheet";
                newLinkEl.href = styleSheet.href;
                target.head.appendChild(newLinkEl);
            }
        }
    });
};

// ==============================================================================
// Portal Component
// Creates an external window
// ==============================================================================

class Portal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.containerEl = document.createElement("div");
        this.externalWindow = null;
    }

    componentDidMount() {
        this.externalWindow = window.open(
            "",
            "",
            "width=800,height=500,left=100,top=50"
        );
        copyStyles(document, this.externalWindow.document);
        this.externalWindow.document.body.appendChild(this.containerEl);
    }

    componentWillUnmount() {
        this.externalWindow.close();
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.containerEl);
    }
}

export default Portal;
